/*
 * Call for price
 * --------------
 * Items priced at $0.00 show no price and no way to add them to the cart.
 *
 * Liquid does the work on first render everywhere: price.liquid, product-grid-price.liquid,
 * product-column-item.liquid, upsell-product.liquid and quick-add-product.liquid output
 * nothing, and cart-bar.liquid renders an empty bar. This script only covers the product
 * page, where picking a different variant re-renders the price and the cart bar but leaves
 * the buy-buttons block alone — so a $0.00 variant would otherwise keep its Add to cart
 * button from whichever variant loaded first.
 */
(function () {
  'use strict';

  function getSelectedVariant(productInfo) {
    var json = productInfo.querySelector('variant-selects [data-selected-variant]');

    if (!json) return null;

    try {
      return JSON.parse(json.innerHTML);
    } catch (e) {
      return null;
    }
  }

  function updateSection(productInfo) {
    var variant = getSelectedVariant(productInfo);

    // No variant picker means the variant never changes, so Liquid's render still stands.
    if (!variant) return;

    var hide = variant.price === 0;

    productInfo.querySelectorAll('[data-zero-price-block]').forEach(function (block) {
      block.classList.toggle('hidden', hide);

      // Only ever disable here. product-form.js already sets the correct state for a
      // priced variant before this runs, and re-enabling would override a sold-out one.
      if (hide) {
        var submitButton = block.querySelector('[data-add-to-cart]');
        if (submitButton) submitButton.setAttribute('disabled', 'disabled');
      }
    });
  }

  function updateAllSections() {
    document.querySelectorAll('product-info').forEach(updateSection);
  }

  if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, updateAllSections);
  }
})();
